import "./index.css";

function HomeFooter() {
  return (
      <div className="home-footer footer-padding">
        <div className="footer-content">
          <p className="footer-p">Made with ❤️ by L & A Studio</p>
        </div>
      </div>
  );
}

export default HomeFooter;
